app.factory("ExamsManagerService", ["$http",
    function ($http) {
        var ExamsManagerService = {};

        ExamsManagerService.fetchExamsSystemStatus = function (params) {
            return $http.get(`/exams/manager/system-status/${params.key}`).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.updateExamsSystemStatus = function (params) {
            return $http.post("/exams/manager/system-status", {id: params.key, value: params.value}).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.fetchComputerSubjects = function () {
            return $http.get("/exams/manager/computer/list").then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.addComputerSubject = function (params) {
            return $http.post("/exams/manager/computer/add", {subjectId: params.subjectId}).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.removeComputerSubject = function (params) {
            return $http.post("/exams/manager/computer/remove", {
                computerSubjectId: params.computerSubjectId
            }).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.fetchSubjectExclusions = function () {
            return $http.get("/exams/manager/exclusion/list").then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.addSubjectExclusion = function (params) {
            return $http.post("/exams/manager/exclusion/add", {subjectId: params.subjectId}).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.removeSubjectExclusion = function (params) {
            return $http.post("/exams/manager/exclusion/remove", {
                subjectExclusionId: params.subjectExclusionId
            }).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.fetchSpecialSubjects = function () {
            return $http.get("/exams/manager/special/list").then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.addSpecialSubject = function (params) {
            return $http.post("/exams/manager/special/add", {
                subjectId: params.subjectId,
                sessions: params.sessions
            }).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.toggleSpecialSession = function (params) {
            return $http.post("/exams/manager/special/session/toggle", {
                specialSubjectId: params.specialSubjectId,
                sessionId: params.sessionId,
                action: params.action
            }).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.removeSpecialSubject = function (params) {
            return $http.post("/exams/manager/special/remove", {
                specialSubjectId: params.specialSubjectId
            }).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.fetchExamHalls = function () {
            return $http.get("/exams/manager/hall/list").then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.addExamHall = function (params) {
            return $http.post("/exams/manager/hall/add", {
                name: params.name,
                ordered: params.ordered,
                seatCount: params.seatCount,
                withComputers: params.withComputers
            }).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.editExamHall = function (params) {
            return $http.post("/exams/manager/hall/edit", {
                examHallId: params.examHallId,
                name: params.name,
                ordered: params.ordered,
                seatCount: params.seatCount,
                withComputers: params.withComputers
            }).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.removeExamHall = function (params) {
            return $http.post("/exams/manager/hall/remove", {examHallId: params.examHallId}).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.fetchExamDays = function () {
            return $http.get("/exams/manager/day/list").then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.addExamDay = function (params) {
            return $http.post("/exams/manager/day/add", {day: params.day}).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.removeExamDay = function (params) {
            return $http.post("/exams/manager/day/remove", {examDayId: params.examDayId}).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.copyExamDay = function (params) {
            return $http.post("/exams/manager/day/copy", {dayId: params.dayId, day: params.day}).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.fetchSessions = function () {
            return $http.get("/exams/manager/session/list").then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.getSessionsWithFreeSeats = function () {
            return $http.get("/exams/manager/session/seat/free").then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.fetchDaySessions = function (params) {
            return $http.get("/exams/manager/day/session/list/" + params.dayId).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.addSession = function (params) {
            return $http.post("/exams/manager/session/add", {
                examHallId: params.examHallId,
                examDayId: params.examDayId,
                time: params.time,
                level: params.level,
            }).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.editSession = function (params) {
            return $http.post("/exams/manager/session/edit", {
                sessionId: params.sessionId,
                hallId: params.hallId,
                examLevel: params.examLevel,
            }).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.removeSession = function (params) {
            return $http.post("/exams/manager/session/remove", {examSessionId: params.examSessionId}).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.fetchExamItems = function (params) {
            return $http.get("/exams/manager/item/list/", {params: params}).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.addExamItem = function (params) {
            return $http.post("/exams/manager/item/add", {
                studentId: params.studentId,
                subjectId: params.subjectId,
                subjectSelectionId: params.subjectSelectionId,
                sessionId: params.sessionId,
                seat: params.seat
            }).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.editExamItem = function (params) {
            return $http.post("/exams/manager/item/edit", {
                examItemId: params.examItemId,
                sessionId: params.sessionId,
                seat: params.seat,
            }).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.removeExamItem = function (params) {
            return $http.post("/exams/manager/item/remove", {examItemId: params.examItemId}).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.changeItemStatus = function (params) {
            return $http.post("/exams/manager/item/status", {
                examItemId: params.examItemId,
                status: params.status
            }).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.fetchUnlistedSubjectsByStudent = function (params) {
            return $http.post("/exams/manager/subject/unlisted", {studentId: params.studentId}).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.generateExams = function (params) {
            return $http.post("/exams/manager/generate", {barrierEnabled: params.barrierEnabled, level: params.level}).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.clearExams = function (level) {
            return $http.post("/exams/manager/clear", {level: level}).then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.ExportExams = function () {
            return $http.get("/exams/manager/export/exam").then(function (resp) {
                return resp.data;
            });
        };

        ExamsManagerService.ExportExams = function () {
            return $http.get("/exams/manager/export/schedule").then(function (resp) {
                return resp.data;
            });
        };

        return ExamsManagerService;
    }
]);
